import { render, staticRenderFns } from "./CreateRateRegisterModal.vue?vue&type=template&id=39760027&scoped=true&"
import script from "./CreateRateRegisterModal.vue?vue&type=script&lang=ts&"
export * from "./CreateRateRegisterModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateRateRegisterModal.vue?vue&type=style&index=0&id=39760027&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39760027",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VTextField})
